import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from 'src/components/ui/dialog';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setStorageTrialLimitOpen } from 'src/store/slices/limitBannerSlice';
import { PATH_DASHBOARD } from 'src/constants/spa-routes';
import { COSSUPORT_DEMO_PAGE } from 'src/shared/constants';

export const LimitReachedPopup = ({}) => {
  const [open, setOpen] = useState(true);

  const dispatch = useDispatch();

  const handleClose = () => setOpen(false);
  const handleOpenChange = (open) => {
    setOpen(open);
    if (!open) {
      dispatch(setStorageTrialLimitOpen(false));
    }
  };

  return (
    <Dialog onOpenChange={handleOpenChange} open={open}>
      <DialogContent className="border-[#009CB240] pb-7.5">
        <DialogHeader>
          <DialogTitle className="w-full items-center justify-center flex">
            <p className="text-[#F5FCFE] font-semibold text-sm bg-[#009CB2] px-2.5 py-1 rounded-full">
              <i>Trial Limit Reached</i>
            </p>
          </DialogTitle>
        </DialogHeader>
        <div className="flex flex-col items-center w-full text-left">
          <p className="text-sm font-medium text-ebony pb-2.5 opacity-80">
            Looks like you’ve reached your limit for free AI responses.
          </p>
          <p className="text-sm font-medium text-ebony opacity-80">Want more free responses?</p>
          <p className="text-sm font-medium">
            <span className="text-ebony opacity-80">Just fill out</span>{' '}
            <Link
              target="_blank"
              to={COSSUPORT_DEMO_PAGE}
              className="text-[#009CB2] underline opacity-80 hover:opacity-100"
              onClick={handleClose}
            >
              <b>
                <i>this form</i>
              </b>
            </Link>{' '}
            <span className="text-ebony opacity-80">or</span>{' '}
            <Link
              to={PATH_DASHBOARD.SUBSCRIPTION}
              className="text-[#009CB2] underline opacity-80 hover:opacity-100"
              onClick={handleClose}
            >
              <b>
                <i>upgrade</i>
              </b>
            </Link>{' '}
            <span className="text-ebony opacity-80">your subscription.</span>
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};
